import { c as _c } from "react/compiler-runtime";
import React from 'react';
export type ButtonProps = {
  icon: React.FC<{
    className?: string;
  }>;
  content?: React.ReactNode;
  boxShadow?: boolean;
  buttonClassName?: string;
  href?: string;
  label?: string;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;
const ButtonFull: React.FC<ButtonProps> = t0 => {
  const $ = _c(16);
  let boxShadow;
  let content;
  let icon;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      icon,
      content,
      className: t1,
      boxShadow,
      buttonClassName: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = boxShadow;
    $[2] = content;
    $[3] = icon;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    boxShadow = $[1];
    content = $[2];
    icon = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const className = t1 === undefined ? "" : t1;
  const buttonClassName = t2 === undefined ? "" : t2;
  const Icon = icon;
  const t3 = `share-button--full ${boxShadow ? "share-button--box-shadowed" : ""} ${buttonClassName} ${className}`;
  let t4;
  if ($[7] !== Icon) {
    t4 = <div className="share-button--full-icon-wrapper"><Icon className="share-button--icon" /></div>;
    $[7] = Icon;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== content) {
    t5 = <span className="share-button--text">{content}</span>;
    $[9] = content;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <a {...props} className={t3}>{t4}{t5}</a>;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
const ButtonMinimal: React.FC<ButtonProps> = t0 => {
  const $ = _c(15);
  let content;
  let icon;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      icon: t3,
      content: t4,
      className: t5,
      buttonClassName: t6,
      boxShadow: _,
      ...t7
    } = t0;
    icon = t3;
    content = t4;
    t1 = t5;
    t2 = t6;
    props = t7;
    $[0] = t0;
    $[1] = content;
    $[2] = icon;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    content = $[1];
    icon = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const className = t1 === undefined ? "" : t1;
  const buttonClassName = t2 === undefined ? "" : t2;
  const Icon = icon;
  const t3 = `share-button--minimal ${buttonClassName} ${className}`;
  let t4;
  if ($[6] !== Icon) {
    t4 = <Icon className="share-button--icon" />;
    $[6] = Icon;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== content) {
    t5 = <span className="share-button--text">{content}</span>;
    $[8] = content;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== props || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <a {...props} className={t3}>{t4}{t5}</a>;
    $[10] = props;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const ButtonRound: React.FC<ButtonProps> = t0 => {
  const $ = _c(12);
  let boxShadow;
  let icon;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      icon,
      className: t1,
      boxShadow,
      buttonClassName: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = boxShadow;
    $[2] = icon;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    boxShadow = $[1];
    icon = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const className = t1 === undefined ? "" : t1;
  const buttonClassName = t2 === undefined ? "" : t2;
  const Icon = icon;
  const t3 = `share-button--round ${boxShadow ? "share-button--box-shadowed" : ""} ${buttonClassName} ${className}`;
  let t4;
  if ($[6] !== Icon) {
    t4 = <Icon />;
    $[6] = Icon;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t3 || $[10] !== t4) {
    t5 = <a {...props} className={t3}>{t4}</a>;
    $[8] = props;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
const ButtonSquare: React.FC<ButtonProps> = t0 => {
  const $ = _c(11);
  let icon;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      icon: t3,
      className: t4,
      buttonClassName: t5,
      boxShadow: _,
      ...t6
    } = t0;
    icon = t3;
    t1 = t4;
    t2 = t5;
    props = t6;
    $[0] = t0;
    $[1] = icon;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    icon = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const className = t1 === undefined ? "" : t1;
  const buttonClassName = t2 === undefined ? "" : t2;
  const Icon = icon;
  const t3 = `share-button--square ${buttonClassName} ${className}`;
  let t4;
  if ($[5] !== Icon) {
    t4 = <Icon />;
    $[5] = Icon;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t3 || $[9] !== t4) {
    t5 = <a {...props} className={t3}>{t4}</a>;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
const ButtonRoundWithLabel: React.FC<ButtonProps> = t0 => {
  const $ = _c(17);
  let boxShadow;
  let content;
  let icon;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      icon,
      content,
      className: t1,
      boxShadow,
      buttonClassName: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = boxShadow;
    $[2] = content;
    $[3] = icon;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    boxShadow = $[1];
    content = $[2];
    icon = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const className = t1 === undefined ? "" : t1;
  const buttonClassName = t2 === undefined ? "" : t2;
  const Icon = icon;
  const t3 = `share-button--round-with-label ${className}`;
  const t4 = `share-button--round ${boxShadow ? "share-button--box-shadowed" : ""} ${buttonClassName}`;
  let t5;
  if ($[7] !== Icon) {
    t5 = <Icon />;
    $[7] = Icon;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== t4 || $[11] !== t5) {
    t6 = <a {...props} className={t4}>{t5}</a>;
    $[9] = props;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== content || $[14] !== t3 || $[15] !== t6) {
    t7 = <div className={t3}>{t6}{content}</div>;
    $[13] = content;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const shapes = {
  full: ButtonFull,
  minimal: ButtonMinimal,
  round: ButtonRound,
  square: ButtonSquare,
  roundWithLabel: ButtonRoundWithLabel
} as const;